import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { checkAuth } from '../../api/axios';

const useAutoLogout = () => {
  const { t } = useTranslation('global');
  const navigate = useNavigate();

  useEffect(() => {
    const checkToken = async () => {
      const accessToken = localStorage.getItem('accessToken');
      if (accessToken)
      {
        const isValid = await checkAuth(accessToken);
        if (!isValid) {
          try {
                handleLogout();
          } catch (error) {
            console.error("Error during auto logout:", error);
          }
        }
      }    
    };

    checkToken();

  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('pagePermissions');
    navigate('/login');
  };
};

export default useAutoLogout;